import { render, staticRenderFns } from "./judgement-card.vue?vue&type=template&id=7f110e70&scoped=true&"
import script from "./judgement-card.vue?vue&type=script&lang=js&"
export * from "./judgement-card.vue?vue&type=script&lang=js&"
import style0 from "./judgement-card.vue?vue&type=style&index=0&id=7f110e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f110e70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBadge,VCard,VDivider,VHover,VIcon})
